import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonProps, ButtonSize, ButtonType } from '../buttons/button.component';

@Component({
  selector: 'app-button-drop-down',
  templateUrl: './button-drop-down.component.html',
  styleUrls: ['./button-drop-down.component.scss'],
})

/** 1.uses as selector drop-down list which contains multiple elements in drop-down list calls by isCheckBox = false;
  2.uses as selector with check-boxes drop-down list with multiple checkboxes properties by isCheckBox = true;
   allows to choose multiple elements
 3.this component created for reminder component, it is possible to use in another place
 */
export class ButtonDropDownComponent {

  @Input() data: any[]; // array of objects typed by user
  @Input() simpleData: string[];
  @Input() field = ''; // needs to provide field of data to display in checkbox
  @Input() isCheckBox = false;
  @Input() displayedItem = '';
  @Input() singleElement = false;
  @Input() selectedOrgUuids: string[] = [];
  @Input() additionalClass: string;
  @Input() selectedItem: string;
  @Input() size: ButtonSize = 'xsmall';
  @Input() buttonType: ButtonType = 'accent';
  @Input() showIcon = ''; // +
  @Input() iconName = ' white-arrow-down.svg'; // +
  @Input() disabled = false; // +
  @Input() showDropDownIcons = false;
  @Input() dropDownIconNameAndStyling = 'edit.svg';
  @Input() showDoubleButton = false;
  @Input() dropDownWidth = 'width-8';
  @Input() buttonProps: ButtonProps;
  @Input() icon = 'plus.svg';
  @Output() selectOneEmitter = new EventEmitter<number>();
  @Output() selectAllEmitter = new EventEmitter<boolean>();
  @Output() selectCurrentOrgEmitter = new EventEmitter();
  @Output() itemEmitter = new EventEmitter<any>();
  /**
   * Handler of clicking on the left button when {@link showDoubleButton} flag is true
   */
  @Output() leftButtonClickEmitter = new EventEmitter<void>();
  /**
   * Reverses the dropdown direction to open upward instead
   * of downward (for input @code{data} or @code{simpleData})
   * @default false
   */
  @Input() reverse: boolean = false;
  showOrgMenu = false;
  allSelected = false;
  isDropdownOpen = false;

  toggleSelectAll(): void {
    this.allSelected = !this.allSelected;
    this.selectAllEmitter.emit(this.allSelected);
  }

  selectCurrentOrg(): void {
    this.selectCurrentOrgEmitter.emit();
  }

  selectOne(i: number): void {
    this.selectOneEmitter.emit(i);
  }
}
